module.exports = __webpack_public_path__ + "img/bootstrap.dd613b39.png";